import { z } from 'zod';

/**
 * Zod schema for item level domain model.
 *
 * This represents the hierarchical level of an item type (e.g., Epic, Story, Task).
 */
export const itemLevelSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  level: z.number().int(),
});

/**
 * Zod schema for item type domain model.
 *
 * This represents the domain model of an item type with its associated level.
 */
export const itemTypeSchema = z.object({
  id: z.number().int().positive(),
  name: z.string(),
  description: z.string().optional(),
  color: z.string().optional(),
  icon: z.string().optional(),
  itemLevel: itemLevelSchema,
});

export type ItemLevelDTO = z.infer<typeof itemLevelSchema>;
export type ItemTypeDTO = z.infer<typeof itemTypeSchema>;
